<template>
  <div class="float-right">
    <b-modal
        @ok="handleCreateOk"
        ref="create-import-modal"
        :title="$t('modal.title.add_new_import')"
        ok-title="Save"
        cancel-title="Cancel"
        size="md">
      <template #modal-header>
        <div class="w-100">
          <h4 class="float-left">{{ $t('modal.title.add_new_import') }}</h4>
          <div class="buttons float-right">
            <b-button type="button" variant="secondary" class="mr-2" @click="hideModal">{{$t('btn.cancel')}}</b-button>
            <b-button type="submit" variant="primary" @click="handleCreateOk">{{$t('btn.save')}}</b-button>
          </div>
        </div>
      </template>
      <div class="create-question">
        <div class="row">
          <div class="col-12">
            <b-form-invalid-feedback

            >This is a required field and must be email.
            </b-form-invalid-feedback>
            <p class="text-danger text-center">{{ $t(errorMessage) }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <b-form-group
                :label="$t('form.label.import_name')"
                label-cols="5"
                class="flat">
              <b-input
                v-model="data.name"
                :state="validateState('name')"
              >
              </b-input>
              <p v-if="$v.data.name.$dirty && !$v.data.name.required" class="text-danger">{{ $t('error.required') }}</p>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <b-form-group
                :label="$t('form.label.specify_question_type')"
                label-cols="5"
                class="flat"
                id="form-type"
            >
              <div class="w-100">
                <multiselect :placeholder="$t('options.select_option')"
                             label="text"
                             track-by="text"
                             v-model="data.type"
                             :options="questionTypes"
                             :multiple="false"
                             :allow-empty="false"
                             :state="validateState('type')"
                >
                </multiselect>
                <p v-if="$v.data.type.$dirty && !$v.data.type.required" class="text-danger">{{ $t('error.required') }}</p>
              </div>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <b-form-group :label="$t('form.label.attach_file')" label-cols-sm="5">
              <b-form-file
                  v-model="file"
                  :placeholder="$t('import.file.choose_label')"
                  :drop-placeholder="$t('import.file.drop_placeholder')"
                  :browse-text="$t('import.file.browse_text')"

                  id="file" ref="file"></b-form-file>
              <p v-if="$v.file.$dirty && !$v.file.required" class="text-danger">{{ $t('error.required') }}</p>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <b-form-group label-cols-sm="5">
              <b-form-checkbox
                  id="checkbox-1"
                  v-model="data.isGeneralKnowledge"
                  name="checkbox-1"
              >
                {{ $t('form.label.add_question_to_general_knowledge_type') }}
              </b-form-checkbox>
            </b-form-group>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100">
          <div class="buttons float-right">
            <b-button type="button" variant="secondary" class="mr-2"  @click="hideModal">{{$t('btn.cancel')}}</b-button>
            <b-button type="submit" variant="primary" @click="handleCreateOk">{{$t('btn.save')}}</b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import {required} from "vuelidate/lib/validators";
import {validationMixin} from "vuelidate";
import Multiselect from "vue-multiselect";

//TODO: import / load / get locale the right way
let locale = locale ? locale : "en";

export default {
  components: {Multiselect},
  mixins: [validationMixin],
  data() {
    return {
      apiKey: null,
      data: {
        name: null,
        type: null,
        isGeneralKnowledge: false
      },
      file: null,
      questionTypes: [
        {value: 'text', text: this.$t('option.text')},
        {value: 'image', text: this.$t('option.image')},
        {value: 'sound', text:this.$t('option.sound')},
        {value: 'video', text: this.$t('option.video')},
      ],
      errorMessage: ''
    };
  },
  validations: {
    data: {
      name: {
        required
      },
      type: {
        required
      }
    },
    file: {
      required
    }
  },
  methods: {
    validateState(entry) {
      entry = this.$v.data[entry];

      const {$dirty, $error} = entry;
      return $dirty ? !$error : null;
    },
    openModal() {
      this.$emit('open-create-import-modal');
      this.resetForm();

      this.$refs['create-import-modal'].show()
    },
    handleCreateOk(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.handleCreateSubmit()
    },
    handleFileUpload(categoryId) {
      this.data.file = this.$refs.file.files[0];
      this.submitFile(categoryId);
    },
    handleCreateSubmit() {
      this.$v.$touch();
      let isValid = this.$v.$invalid === false;

      if (isValid) {
        let formData = new FormData();

        const data = {
          name: this.data.name,
          type: this.data.type.value,
          isGeneralKnowledge: this.data.isGeneralKnowledge
        }

        formData.append('data', JSON.stringify(data));
        formData.append('file', this.file);

        axios.post( `/api/question/import`,
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
        ).then(() => {
          setTimeout(() => {
            this.$parent.$emit('refreshGrid');
            this.hideModal();
          }, 1000);
        }).catch(error => {
          this.createErrorMessage(error);
        });
      }
    },
    createErrorMessage(error) {
      const invalidCsvErrorCode = '744f00bc-4389-4c74-92de-9a43cde55534';
      const violationsArray = error.response.data.violations;
      const errorMessages = [];

      if (error.response) {
        if(error.response.data.message) {
          this.errorMessage = `error.${error.response.data.message}`;

          return;
        }

        if(violationsArray) {
          const errorWithInvalidCsvErrorCode = violationsArray.find(violation => {
            return violation.code === invalidCsvErrorCode;
          });

          if(errorWithInvalidCsvErrorCode) {
            this.errorMessage = this.$t('error.invalid_csv');
            return;
          }

          violationsArray.forEach(violation => {
            errorMessages.push(violation.parameters.column);
          });

          this.errorMessage = `${this.$t('error.invalid_column_in_csv')} ${errorMessages.toString().replace(',', ', ')}`;

          return;
        }

        this.errorMessage = 'error.something_went_wrong';

        return;
      }

      if(error.message) {
        this.errorMessage = error.message;

        return;
      }

      this.errorMessage = 'error.something_went_wrong'
    },
    resetProperties() {
      this.data = {
        name: '',
        type: ''
      }
    },
    resetForm() {
      this.$v.$reset();
    },
    hideModal() {
      this.resetProperties();

      this.$parent.getStatuses();
      this.$refs['create-import-modal'].hide();
    }
  }
}
</script>
